import { collectionServiceClient } from "@/api/collectionServiceClient";
import { GetOcrMarkCaseReq } from "@/pbjs/xcommon/collection_pb.js";
import InnerRequest from "./request";
// lee 绩效接口参数
interface Options {
  ticketId: number;
}

export function setGetOcrMarkCaseReq(arg: Options) {
    let request: any = new GetOcrMarkCaseReq();
    request.setTicketid(arg.ticketId);
    console.log("GetOcrMarkCaseReq", arg, request);
    return request;
}

export const getOcrMarkCaseRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.getOcrMarkCase
);
